const defaultSlider = (container, options = 0) => {

    const $container = $(container);

    if(options === 0) {
        options = {
            items: 3,
            loop: true,
            margin: 18,
            responsive: {

                992 : {
                    items: 3
                },

                768 : {
                    items: 2
                },

                0 : {
                    items: 1
                }
            }
        }
    }


    $container.owlCarousel(options)

};

export default defaultSlider;